import CreateHttpClient from '../createTimetablesWebApiHttpClient';
import { AxiosInstance } from 'axios';
import { checkConflictWithBreak, convertToTimetableObject, WednesdayBreak } from '../../helpers/helpers';
import { BUSINESS_SCHOOL_ID } from '../../constants';

class TimetableApi {
    httpClient: AxiosInstance;

    constructor() {
        this.httpClient = CreateHttpClient();
    }

    async GetInstructors(schoolId?: number, campusId?: number) {
        let url = `/timetables/instructors`;

        if (schoolId) url += `?schoolId=${schoolId}`;
        if (campusId && schoolId) url += `&campusId=${campusId}`;
        else if (campusId) url += `?campusId=${campusId}`;

        const { data } = await this.httpClient.get(url);
        return data;
    }

    async GetInstructorsBySet(termSchoolId: number, setId: number) {
        const { data } = await this.httpClient.get(`/timetables/instructors/termSchool/${termSchoolId}/set/${setId}`);

        return data;
    }

    //TODO: API IS NOT BUILT YET
    async GetInstructorsBySubject(subject) {
        const { data } = await this.httpClient.get(`/api/Instructor/BySubject?subject=${subject}`);
        return data;
    }

    async GetDepartments(schoolId?: number, campusId?: number) {
        let url = `/department`;

        if (schoolId) url += `?schoolId=${schoolId}`;
        if (campusId && schoolId) url += `&campusId=${campusId}`;
        else if (campusId) url += `?campusId=${campusId}`;

        const { data } = await this.httpClient.get(url);
        return data;
    }

    async GetSets(departmentId) {
        const { data } = await this.httpClient.get(`/timetables/sets/department/${departmentId}`);
        return data;
    }

    async GetAllBuildings(campusId?: number) {
        let url = `/timetables/buildings`;
        if (campusId) url += `?campusId=${campusId}`;
        const { data } = await this.httpClient.get(url);
        return data;
    }

    async GetRooms(buildingId: number) {
        const { data } = await this.httpClient.get(`/timetables/rooms/building/${buildingId}`);
        return data;
    }

    async GetByInstructor({ instructorID, termSchoolID, termCampusId, week, schoolID }) {
        let url = `timetables/instructor?instructorId=${instructorID}&week=${week}`;
        url = this.AddQueryParameters(url, termSchoolID, termCampusId);
        const { data } = await this.httpClient.get(url);

        let timetables = convertToTimetableObject(data.timetables);
        const conflicts = convertToTimetableObject(data.conflicts);

        if (schoolID === BUSINESS_SCHOOL_ID) {
            const result = checkConflictWithBreak(timetables);

            if (result === undefined) {
                timetables.push(WednesdayBreak());
            }
        }

        return {
            timetables: timetables,
            conflicts: conflicts,
            config: data.config,
        };
    }

    async GetBySet({ setID, termSchoolID, termCampusId, week, schoolID }) {
        let url = `timetables/set?setId=${setID}&week=${week}`;
        url = this.AddQueryParameters(url, termSchoolID, termCampusId);
        const { data } = await this.httpClient.get(url);

        let timetables = convertToTimetableObject(data.timetables);
        const conflicts = convertToTimetableObject(data.conflicts);

        if (schoolID === BUSINESS_SCHOOL_ID) {
            const result = checkConflictWithBreak(timetables);

            if (result === undefined) {
                timetables.push(WednesdayBreak());
            }
        }

        return {
            timetables: timetables,
            conflicts: conflicts,
            config: data.config,
        };
    }

    async GetByRoom({ roomID, termSchoolID, termCampusId, week }) {
        let url = `timetables/room?roomId=${roomID}&week=${week}`;
        url = this.AddQueryParameters(url, termSchoolID, termCampusId);
        const { data } = await this.httpClient.get(url);

        const timetables = convertToTimetableObject(data.timetables);
        const conflicts = convertToTimetableObject(data.conflicts);

        return {
            timetables: timetables,
            conflicts: conflicts,
            config: data.config,
        };
    }

    //either termSchoolId or termCampusId can be passed. Not both at the same time.
    private AddQueryParameters(url: string, termSchoolId: number, termCampusId: number) {
        if (termSchoolId) {
            url += `&termSchoolId=${termSchoolId}`;
        }

        if (termCampusId) {
            url += `&termCampusId=${termCampusId}`;
        }

        return url;
    }
}

export default TimetableApi;
